module.exports = require('./lib/immutable')



//////////////////
// WEBPACK FOOTER
// ./~/redux-form/immutable.js
// module id = 3033
// module chunks = 0